// Keyboard.js
import React from 'react';
import './Keyboard.css';

const rows = [
  ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', 'DEL'],
  ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'],
  ['z', 'x', 'c', 'v', 'b', 'n', 'm']
];

const Keyboard = ({ onKeyPress }) => {
  return (
    <div className="keyboard-container">
      {rows.map((row, rowIndex) => (
        <div key={rowIndex} className="keyboard-row">
          {row.map((key) => (
            <div key={key} className="key" onClick={() => onKeyPress(key)}>
              {key}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default Keyboard;